import React, { useEffect, useReducer } from 'react';
import useAuth from '../../../hooks/useAuth';
import Loader from '../../../utils/Loader';
import Validation from '../../../utils/Validation';
// import { UpdateAccountForSuperAdmin } from '../../../actions/authAction';
import ToastHot from 'react-hot-toast';
import Reducer from '../../../services/Reducer';
import { useDispatch, useSelector } from 'react-redux';
import api from "../../../services/Axios"; // ✅ add your axios instance
import { updateUserProfile } from '../../../redux/slice/user';

// ✅ APIs
const ME_API = "/me";
const UPDATE_PROFILE_API = "/update-profile";

const initStateEditProfileErr = {
    email: '',
    phoneNo: '',
    
    firstName: '',
    lastName: '',

    loading: false,
    validate: false
};
const generalStateEditProfileErr = {
    firstNameErrBlank: false,
    lastNameErrBlank: false,
    validFirstnameError: false,
    validLastnameError: false,

    emailErrBlank: false,
    IsValidEmail: false,
    IsExistEmail: false,

    phoneErrBlank: false,
    IsValidPhone: false,
    IsExistPhone: false,

};

export default function EditProfile() {
    const [state, dispatch] = useReducer(Reducer, initStateEditProfileErr);
    const storeDispatch=useDispatch()
    const [stateForErr, dispatchForErr] = useReducer(Reducer, generalStateEditProfileErr);
    // const { user, updateUser } = useAuth();
    const { user } = useSelector((state) => state.user);

    const getAuthHeader = () => ({
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    });

    useEffect(() => {
        fetchMe()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const fetchMe = async () => {
        dispatch({ type: 'LOAD', payload: true });

        const header = getAuthHeader();

        const response = await api
            .get(ME_API, header)
            .then((res) => res)
            .catch((err) => err?.response);

        dispatch({ type: 'LOAD', payload: false });

        if (response?.data?.success) {
            const me = response?.data?.data || {};

            dispatch({ type: "SETDATA", payload: { "name": "firstName", "value": me.firstName || "" } })
            dispatch({ type: "SETDATA", payload: { "name": "lastName", "value": me.lastName || "" } })
            dispatch({ type: "SETDATA", payload: { "name": "email", "value": me.email || "" } })
            dispatch({ type: "SETDATA", payload: { "name": "phoneNo", "value": me.phone || "" } })
        } else {
            ToastHot.error(response?.data?.message || "Failed to load profile");
        }
    }

    const getAllUserInfo = () => {
        dispatch({ type: "SETDATA", payload: { "name": "firstName", "value": user.firstName } })
        dispatch({ type: "SETDATA", payload: { "name": "lastName", "value": user.lastName } })
        dispatch({ type: "SETDATA", payload: { "name": "email", "value": user.email } })
        dispatch({ type: "SETDATA", payload: { "name": "phoneNo", "value": user.phone } })
    }

    const onChangeGetDataAllData = (e) => {
        if (e.target.name === "email") {
            if (!Validation.text(e.target.value)) {
                dispatchForErr({ type: 'VALIDATECHECK', payload: { name: 'emailErrBlank', value: true } });

                dispatchForErr({ type: 'VALIDATECHECK', payload: { name: 'IsExistEmail', value: false } });
                dispatchForErr({ type: 'VALIDATECHECK', payload: { name: 'IsValidEmail', value: false } });
                console.log('email')
            }
            else if (!Validation.email(e.target.value.toLowerCase())) {
                dispatchForErr({ type: 'VALIDATECHECK', payload: { name: 'emailErrBlank', value: false } });
                dispatchForErr({ type: 'VALIDATECHECK', payload: { name: 'IsExistEmail', value: false } });
                
                dispatchForErr({ type: 'VALIDATECHECK', payload: { name: 'IsValidEmail', value: true } });
            } else {
                //Email
                dispatchForErr({ type: 'VALIDATECHECK', payload: { name: 'emailErrBlank', value: false } });
                dispatchForErr({ type: 'VALIDATECHECK', payload: { name: 'IsValidEmail', value: false } });
                dispatchForErr({ type: 'VALIDATECHECK', payload: { name: 'IsExistEmail', value: false } });
            }
        }
        
        //Firstnames
        if ( e.target.name ===  "firstName" ) {
            if (!Validation.text( e.target.value )) {
                dispatchForErr({ type: 'VALIDATECHECK', payload: { name: 'firstNameErrBlank', value: true } });
                dispatchForErr({ type: 'VALIDATECHECK', payload: { name: 'validFirstnameError', value: false } })
            } else if ( !Validation.nameFields( e.target.value )) {
                dispatchForErr({ type: 'VALIDATECHECK', payload: { name: 'firstNameErrBlank', value: false } });
                dispatchForErr({ type: 'VALIDATECHECK', payload: { name: 'validFirstnameError', value: true } })
                console.log('firstname')
            } else {
                dispatchForErr({ type: 'VALIDATECHECK', payload: { name: 'firstNameErrBlank', value: false } });
                dispatchForErr({ type: 'VALIDATECHECK', payload: { name: 'validFirstnameError', value: false } });
            }
        }

        if (e.target.name === "lastName" ) {
            if (!Validation.text( e.target.value )) {
                dispatchForErr({ type: 'VALIDATECHECK', payload: { name: 'lastNameErrBlank', value: true } });
                dispatchForErr({ type: 'VALIDATECHECK', payload: { name: 'validLastnameError', value: false } })
                console.log('last')
            } else if (!Validation.nameFields( e.target.value )) {
                dispatchForErr({ type: 'VALIDATECHECK', payload: { name: 'lastNameErrBlank', value: false } });
                dispatchForErr({ type: 'VALIDATECHECK', payload: { name: 'validLastnameError', value: true } });
            } else {
                console.log('last else')
                dispatchForErr({ type: 'VALIDATECHECK', payload: { name: 'lastNameErrBlank', value: false } });
                dispatchForErr({ type: 'VALIDATECHECK', payload: { name: 'validLastnameError', value: false } });
            }
        }

        if (e.target.name === "phoneNo") {
            if (!Validation.text(e.target.value)) {
                dispatchForErr({ type: 'VALIDATECHECK', payload: { name: 'phoneErrBlank', value: true } });
                dispatchForErr({ type: 'VALIDATECHECK', payload: { name: 'IsExistPhone', value: false } });
                dispatchForErr({ type: 'VALIDATECHECK', payload: { name: 'IsValidPhone', value: false } });
            }
            else if (!Validation.mobile(e.target.value)) {
                dispatchForErr({ type: 'VALIDATECHECK', payload: { name: 'IsValidPhone', value: true } });
                dispatchForErr({ type: 'VALIDATECHECK', payload: { name: 'IsExistPhone', value: false } });
                dispatchForErr({ type: 'VALIDATECHECK', payload: { name: 'phoneErrBlank', value: false } });
            } else {
                dispatchForErr({ type: 'VALIDATECHECK', payload: { name: 'phoneErrBlank', value: false } });
                dispatchForErr({ type: 'VALIDATECHECK', payload: { name: 'IsValidPhone', value: false } });
                dispatchForErr({ type: 'VALIDATECHECK', payload: { name: 'IsExistPhone', value: false } });
            }
        }
        dispatch({ type: "ONCHANGE", payload: e })

    }
    
    const onProfileUpdate = async (e) => {
        e.preventDefault();
        let validationStatus = await getValidation();
        if (validationStatus) {
            const payload = {
                firstName: state.firstName,
                lastName: state.lastName,
                phone: state.phoneNo
            };

            dispatch({ type: 'LOAD', payload: true });

            const header = getAuthHeader();

            const response = await api
                .patch(UPDATE_PROFILE_API, payload, header)
                .then((res) => res)
                .catch((err) => err?.response);
            storeDispatch(updateUserProfile(payload))
            dispatch({ type: 'LOAD', payload: false });

            if (response?.data?.success) {
                ToastHot.success(response?.data?.message || 'Successfully account updated.');
                // ✅ refresh data from ME after update
                fetchMe();
            } else {
                ToastHot.error(response?.data?.message || "Something went wrong");
            }
        }
    };

    const getValidation = () => {
        return new Promise((resolve, reject) => {
            if (Validation.text(state.firstName) &&
                Validation.nameFields(state.firstName) &&
                Validation.nameFields(state.lastName) &&
                Validation.text(state.lastName) &&
                Validation.text(state.phoneNo) &&
                Validation.mobile(state.phoneNo)

            ) {
                resolve(true)
            } else {

                if (!Validation.text(state.firstName)) {
                    dispatchForErr({ type: 'VALIDATECHECK', payload: { name: 'firstNameErrBlank', value: true } });
                    console.log('firstname')
                } else if (!Validation.nameFields(state.firstName)) {
                    dispatchForErr({ type: 'VALIDATECHECK', payload: { name: 'validFirstnameError', value: true } });
                    console.log('firstname')
                }

                if (!Validation.text(state.lastName)) {
                    dispatchForErr({ type: 'VALIDATECHECK', payload: { name: 'lastNameErrBlank', value: true } });
                    console.log('lastname')
                } else if (!Validation.nameFields(state.lastName)) {
                    dispatchForErr({ type: 'VALIDATECHECK', payload: { name: 'validLastnameError', value: true } });
                    console.log('lastName')
                }

                if (!Validation.text(state.phoneNo)) {
                    dispatchForErr({ type: 'VALIDATECHECK', payload: { name: 'phoneErrBlank', value: true } });
                    console.log('phone')
                }
                else if (!Validation.mobile(state.phoneNo)) {
                    dispatchForErr({ type: 'VALIDATECHECK', payload: { name: 'IsValidPhone', value: true } });
                    dispatchForErr({ type: 'VALIDATECHECK', payload: { name: 'IsExistPhone', value: false } });
                }
                resolve(false)
            }
        });
    }

    

    return (
        <div className="createNewAccountPage">
            <div className="createNewAccountInner">
                <h1> Edit Profile</h1>
                <form>
                    <div className="row">
                        <div className="col-md-6">
                            <div className="formGroup">
                                <label>First Name</label>
                                <div className="inputgroup ">
                                    <input type="text"
                                        className={(stateForErr.firstNameErrBlank || stateForErr.validFirstnameError) ? "form-control red-border" : "form-control"}
                                        id="firstName"
                                        value={state.firstName}
                                        onChange={onChangeGetDataAllData}
                                        name="firstName"
                                        placeholder=""
                                    />
                                    {/* <img src="/images/user.svg" class="rightSide" /> */}
                                </div>
                                {stateForErr.firstNameErrBlank &&
                                    <p className="error-msg">First name is required.</p>
                                }
                                {stateForErr.validFirstnameError &&
                                    <p className="error-msg">First name is not valid.</p>
                                }
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="formGroup">
                                <label>Last Name</label>
                                <div className="inputgroup ">
                                {/* inputgroupRight */}
                                    <input type="text"
                                        className={(stateForErr.lastNameErrBlank || stateForErr.validLastnameError) ? "form-control red-border" : "form-control"}
                                        id="lastName"
                                        value={state.lastName}
                                        onChange={onChangeGetDataAllData}
                                        name="lastName"
                                        placeholder=""
                                    />
                                    {/* <img src="/images/user.svg" class="rightSide" /> */}
                                </div>
                                {stateForErr.lastNameErrBlank &&
                                    <p className="error-msg">Last name is required.</p>
                                }
                                {stateForErr.validLastnameError &&
                                    <p className="error-msg">Last name is not valid.</p>
                                }
                            </div>
                        </div>

                        <div className="col-md-6">
                            <div className="formGroup">
                                <label>Email Address</label>
                                <div className="inputgroup inputgroupRight">
                                    <input type="text"
                                        id="email"
                                        disabled
                                        value={state.email}
                                        onChange={onChangeGetDataAllData}
                                        name="email"
                                        placeholder="tim.jennings@example.com"
                                        className={(stateForErr.emailErrBlank || stateForErr.IsValidEmail || stateForErr.IsExistEmail) ? "form-control red-border" : "form-control"}
                                    />
                                    <img src="/images/email.svg" class="rightSide" alt="" />
                                </div>
                                {stateForErr.emailErrBlank &&
                                    <p className="error-msg">Email is required.</p>
                                }
                                {stateForErr.IsValidEmail &&
                                    <p className="error-msg">Valid Email is required.</p>
                                }
                                {stateForErr.IsExistEmail &&
                                    <p className="error-msg">Already Exist this email.</p>
                                }
                            </div>
                        </div>

                        <div className="col-md-6">
                            <div className="formGroup">
                                <label>Phone Number </label>
                                <div className="inputgroup inputgroupRight">
                                    <input type="tel"
                                        id="phoneNo"
                                        value={state.phoneNo}
                                        onChange={onChangeGetDataAllData}
                                        name="phoneNo"
                                        // placeholder="insert phone number"
                                        className={(stateForErr.phoneErrBlank || stateForErr.IsValidPhone) ? "form-control red-border" : "form-control"}
                                    />
                                    <img src="/images/phone-icon.svg" class="rightSide" alt=""  />
                                </div>
                                {stateForErr.phoneErrBlank &&
                                    <p className="error-msg">Phone no is required.</p>
                                }
                                {stateForErr.IsValidPhone &&
                                    <p className="error-msg">Valid Phone no is required.</p>
                                }
                            </div>
                        </div>
                        <div class="col-12">
                        <button className="themeBtn fullBtn" disabled={state.loading ? true : false} onClick={onProfileUpdate}>
                                {
                                    state.loading ? <Loader loaderWidth={"30px"} loaderHeight={"30px"} position={"relative"} /> : "SAVE"
                                }
                                </button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    )
}
